const Details = ({ label, value, classes, isHighLighted }) => {
  const classNames = isHighLighted
    ? `${classes.value} ${classes.valueHighlighted}`
    : classes.value;
  return (
    <div className={classes.valueContainer}>
      <span className={classes.label}>{label}</span>
      <span className={classNames}>{value}</span>
    </div>
  );
};

export const ExceptionDetailsDefault = ({
  classes,
  exceptionDetails,
  packageTypeList,
}) => {
  const packageType = packageTypeList.find(
    (packageType) => packageType.value === exceptionDetails.packageType
  )?.label;
  return (
    <>
      <Details
        label="Exception Pieces"
        value={exceptionDetails.pieces}
        classes={classes}
        isHighLighted={true}
      />
      <Details
        label="Package Type"
        value={packageType}
        classes={classes}
        isHighLighted={false}
      />
      <Details
        label="Exception Description"
        value={exceptionDetails.description}
        classes={classes}
        isHighLighted={false}
      />
    </>
  );
};
